/* eslint-disable react/no-array-index-key */
import { Col, Row } from 'antd';
import { DataOuterContainerStyled } from 'components/common/Input/controlled/styled';
import { INPUT_TYPE, LABEL_TYPE } from 'components/common/Input/types';
import { flatten, get } from 'lodash';
import React from 'react';

import { ControlledInputStyled, DataContainerStyled, LabelStyled, SideFieldContainerColStyled } from './styled';
import { DataFieldProps, DataSideFieldProps, InputProps, InputPropsSideField, ISize } from './types';

const fieldMarginBottom = 20;

const InputFieldsGenerator: React.FC<{
  formFields?: InputProps[];
  dataFields?: DataFieldProps[];
  className?: string;
}> = ({ formFields, dataFields, className }) => {
  const generateSideInputFields = (
    sideField: InputPropsSideField,
    index: number,
    fullSideFields: InputPropsSideField[],
    sideFieldSize: ISize,
  ) => {
    const sideFieldName = sideField.name;
    const sideFieldDefaultValue = sideField.defaultValue;

    return (
      <SideFieldContainerColStyled
        key={sideFieldName}
        span={sideFieldSize.span || 24}
        xs={sideFieldSize.xs}
        sm={sideFieldSize.sm}
        md={sideFieldSize.md}
        lg={sideFieldSize.lg}
        xl={sideFieldSize.xl}
        style={{}}>
        <ControlledInputStyled
          {...sideField}
          placeholder={sideField.placeholder}
          type={get(sideField, 'type', INPUT_TYPE.TEXT)}
          name={sideFieldName}
          label={sideField.label || ''}
          labelType={sideField.labelType || LABEL_TYPE.above}
          inputOptions={sideField.inputOptions}
          defaultValue={sideFieldDefaultValue}
          disabled={sideField.disabled}
          inputSettings={sideField.inputSettings}
          onChange={sideField.onChange}
          addressSuggestion={sideField.addressSuggestion}
          addressSuggestionSubFields={sideField.addressSuggestionSubFields}
        />
      </SideFieldContainerColStyled>
    );
  };

  const generateInputFields = (input: InputProps) => {
    const inputName = input.name;
    const inputType = input.type || INPUT_TYPE.TEXT;
    const inputLabel = input.label;
    const inputOptions = get(input, 'inputOptions');
    const inputSettings = get(input, 'inputSettings');
    const { defaultValue, value, sideFields, disabled, onChange } = input;
    const labelType = get(input, 'labelType', LABEL_TYPE.above);
    // initValues[inputName] = defaultValue;
    let totalSideFieldSizeSpan = 0;
    let totalSideFieldSizeXs = 0;
    let totalSideFieldSizeSm = 0;
    let totalSideFieldSizeMd = 0;
    let totalSideFieldSizeLg = 0;
    let totalSideFieldSizeXl = 0;
    const SideFields = sideFields?.map((sideFieldsData, sideFieldIndex, fullSideFields) => {
      const defaultSideFieldSize = 12 / get(fullSideFields, 'length', 1);
      const sideFieldSizes = get(sideFieldsData, 'size');
      let sideFieldSizeSpan: undefined | number = 0;
      let sideFieldSizeXs: undefined | number = 0;
      let sideFieldSizeSm: undefined | number = 0;
      let sideFieldSizeMd: undefined | number = 0;
      let sideFieldSizeLg: undefined | number = 0;
      let sideFieldSizeXl: undefined | number = 0;
      if (sideFieldSizes) {
        const isSideFieldSizeObject = typeof sideFieldSizes === 'object';
        sideFieldSizeSpan = isSideFieldSizeObject ? get(sideFieldSizes, 'span') : undefined;
        sideFieldSizeXs = isSideFieldSizeObject ? get(sideFieldSizes, 'xs') : undefined;
        sideFieldSizeSm = isSideFieldSizeObject ? get(sideFieldSizes, 'sm') : undefined;
        sideFieldSizeMd = isSideFieldSizeObject ? get(sideFieldSizes, 'md') : sideFieldSizes;
        sideFieldSizeLg = isSideFieldSizeObject ? get(sideFieldSizes, 'lg') : undefined;
        sideFieldSizeXl = isSideFieldSizeObject ? get(sideFieldSizes, 'xl') : undefined;
      }
      totalSideFieldSizeMd = sideFieldSizeMd
        ? totalSideFieldSizeMd + sideFieldSizeMd
        : totalSideFieldSizeMd + defaultSideFieldSize;
      totalSideFieldSizeLg = sideFieldSizeLg ? totalSideFieldSizeLg + sideFieldSizeLg : totalSideFieldSizeLg;
      totalSideFieldSizeXl = sideFieldSizeXl ? totalSideFieldSizeXl + sideFieldSizeXl : totalSideFieldSizeXl;
      totalSideFieldSizeSm = sideFieldSizeSm ? totalSideFieldSizeSm + sideFieldSizeSm : totalSideFieldSizeSm;
      totalSideFieldSizeXs = sideFieldSizeXs ? totalSideFieldSizeXs + sideFieldSizeXs : totalSideFieldSizeXs;
      totalSideFieldSizeSpan = sideFieldSizeSpan ? totalSideFieldSizeSpan + sideFieldSizeSpan : totalSideFieldSizeSpan;
      return generateSideInputFields(sideFieldsData, sideFieldIndex, fullSideFields, {
        span: sideFieldSizeSpan,
        xs: sideFieldSizeXs,
        md: sideFieldSizeMd,
        lg: sideFieldSizeLg,
        xl: sideFieldSizeXl,
        sm: sideFieldSizeSm,
      });
    });

    return (
      <React.Fragment key={inputName}>
        <Row style={{ flexWrap: 'wrap' }} justify='space-between'>
          {SideFields}
          <Col
            span={totalSideFieldSizeSpan ? 24 - totalSideFieldSizeSpan : 24}
            xs={totalSideFieldSizeXs ? 24 - totalSideFieldSizeXs : undefined}
            sm={totalSideFieldSizeSm ? 24 - totalSideFieldSizeSm : undefined}
            md={totalSideFieldSizeMd ? 24 - totalSideFieldSizeMd : undefined}
            lg={totalSideFieldSizeLg ? 24 - totalSideFieldSizeLg : undefined}
            xl={totalSideFieldSizeXl ? 24 - totalSideFieldSizeXl : undefined}
            flex={totalSideFieldSizeMd ? undefined : 'auto'}
            style={{}}>
            <ControlledInputStyled
              // key={index}
              {...input}
              placeholder={input.placeholder}
              type={inputType}
              name={inputName}
              label={inputLabel}
              labelType={labelType}
              inputOptions={inputOptions}
              inputSettings={inputSettings}
              // extra={extra}
              onChange={onChange}
              disabled={disabled}
              defaultValue={defaultValue}
              value={value}
              addressSuggestion={input.addressSuggestion}
              addressSuggestionSubFields={input.addressSuggestionSubFields}
            />
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  const generateDataSideFields = (
    sideField: DataSideFieldProps,
    index: number,
    fullSideFields: DataSideFieldProps[],
    sideFieldSize: ISize,
  ) => {
    const { labelType = LABEL_TYPE.above, label, value } = sideField;
    // const sideFieldDefaultValue = sideField.defaultValue || get(userData, sideFieldName, '');
    // totalSideFieldSizeMd += sideFieldSize;
    // initValues[sideFieldName] = sideFieldDefaultValue;
    // manySideFieldNames.push(sideFieldName);
    // if (!sideField.disabled) {
    //   finalFieldsNames.push(sideFieldName);
    // }
    return (
      <Col
        key={`${sideField.label} ${sideField.value}`}
        span={24}
        xs={sideFieldSize.xs}
        sm={sideFieldSize.sm}
        md={sideFieldSize.md}
        lg={sideFieldSize.lg}
        xl={sideFieldSize.xl}
        style={{ marginBottom: fieldMarginBottom }}>
        <DataOuterContainerStyled className='data-field-container' labelType={labelType}>
          {label && (
            <LabelStyled $labelType={labelType}>
              <span>{label}</span>
            </LabelStyled>
          )}
          <DataContainerStyled>{value}</DataContainerStyled>
        </DataOuterContainerStyled>
      </Col>
    );
  };

  const generateDataFields = (data: DataFieldProps) => {
    const { labelType = LABEL_TYPE.above, label, value, sideFields } = data;
    let totalSideFieldSizeSpan = 0;
    let totalSideFieldSizeXs = 0;
    let totalSideFieldSizeSm = 0;
    let totalSideFieldSizeMd = 0;
    let totalSideFieldSizeLg = 0;
    let totalSideFieldSizeXl = 0;
    const SideFields = sideFields?.map((sideFieldsData, sideFieldIndex, fullSideFields) => {
      const defaultSideFieldSize = 12 / get(fullSideFields, 'length', 1);
      const sideFieldSizes = get(sideFieldsData, 'size');
      let sideFieldSizeSpan: undefined | number = 0;
      let sideFieldSizeXs: undefined | number = 0;
      let sideFieldSizeSm: undefined | number = 0;
      let sideFieldSizeMd: undefined | number = 0;
      let sideFieldSizeLg: undefined | number = 0;
      let sideFieldSizeXl: undefined | number = 0;
      if (sideFieldSizes) {
        const isSideFieldSizeObject = typeof sideFieldSizes === 'object';
        sideFieldSizeSpan = isSideFieldSizeObject ? get(sideFieldSizes, 'span') : undefined;
        sideFieldSizeXs = isSideFieldSizeObject ? get(sideFieldSizes, 'xs') : undefined;
        sideFieldSizeSm = isSideFieldSizeObject ? get(sideFieldSizes, 'sm') : undefined;
        sideFieldSizeMd = isSideFieldSizeObject ? get(sideFieldSizes, 'md') : sideFieldSizes;
        sideFieldSizeLg = isSideFieldSizeObject ? get(sideFieldSizes, 'lg') : undefined;
        sideFieldSizeXl = isSideFieldSizeObject ? get(sideFieldSizes, 'xl') : undefined;
      }
      totalSideFieldSizeSpan = sideFieldSizeSpan ? totalSideFieldSizeSpan + sideFieldSizeSpan : totalSideFieldSizeSpan;
      totalSideFieldSizeXs = sideFieldSizeXs ? totalSideFieldSizeXs + sideFieldSizeXs : totalSideFieldSizeXs;
      totalSideFieldSizeSm = sideFieldSizeSm ? totalSideFieldSizeSm + sideFieldSizeSm : totalSideFieldSizeSm;
      totalSideFieldSizeMd = sideFieldSizeMd
        ? totalSideFieldSizeMd + sideFieldSizeMd
        : totalSideFieldSizeMd + defaultSideFieldSize;
      totalSideFieldSizeLg = sideFieldSizeLg ? totalSideFieldSizeLg + sideFieldSizeLg : totalSideFieldSizeLg;
      totalSideFieldSizeXl = sideFieldSizeXl ? totalSideFieldSizeXl + sideFieldSizeXl : totalSideFieldSizeXl;
      return generateDataSideFields(sideFieldsData, sideFieldIndex, fullSideFields, {
        span: sideFieldSizeSpan,
        xs: sideFieldSizeXs,
        md: sideFieldSizeMd,
        lg: sideFieldSizeLg,
        xl: sideFieldSizeXl,
        sm: sideFieldSizeSm,
      });
    });

    return (
      <React.Fragment key={`${data.label} ${data.value}`}>
        <Row style={{ flexWrap: 'wrap' }} justify='space-between'>
          {SideFields}
          <Col
            span={totalSideFieldSizeSpan ? 24 - totalSideFieldSizeSpan : 24}
            xs={totalSideFieldSizeXs ? 24 - totalSideFieldSizeXs : undefined}
            sm={totalSideFieldSizeSm ? 24 - totalSideFieldSizeSm : undefined}
            md={totalSideFieldSizeMd ? 24 - totalSideFieldSizeMd : undefined}
            lg={totalSideFieldSizeLg ? 24 - totalSideFieldSizeLg : undefined}
            xl={totalSideFieldSizeXl ? 24 - totalSideFieldSizeXl : undefined}
            style={{ marginBottom: fieldMarginBottom }}>
            <DataOuterContainerStyled className='data-field-container' labelType={labelType}>
              {label && (
                <LabelStyled $labelType={labelType}>
                  <span>{label}</span>
                </LabelStyled>
              )}
              {flatten([value]).map((v, dataIndex) => (
                <DataContainerStyled key={dataIndex}>{v || 'None'}</DataContainerStyled>
              ))}
            </DataOuterContainerStyled>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  return (
    <div className={className}>
      {formFields && formFields.map(generateInputFields)}
      {dataFields && dataFields.map(generateDataFields)}
    </div>
  );
};

export default React.memo(InputFieldsGenerator);
